<template>
  <div class="flex flex-col items-center">
    <create-new-folder
      :data-to-show="isCreateFolderPopupDisplayed"
      :errors="errorsCreateNewFolder"
      @showChange="(val) => {displayPopupAddNewFolder(val)}"
      @createNewFolder="(folder) => {createFolder(folder)}"
    />

    <add-new-file
      :data-to-show="stateAddFilePopup"
      @showChange="(val) => {changeStatePopupAddNewFile(val)}"
      :loading="addNewFileLoading"
      @addTempFile="(data) => {addTempFile(data)}"
      @addFile="(infos) => {addFile(infos)}"
      :file-temp="fileTemp"
      :errors="errorsAddNewFile"
    />

    <div class="text-gray-600 flex flex-col space-y-2 text-center mb-10">
      <p>
        Votre dépôt de documents est vierge,
      </p>
      <p v-if="canEdit">
        commencez par déposer votre premier fichier ou créer un dossier.
      </p>
    </div>
    <div 
      v-if="canEdit"
      class="flex space-x-6 mb-15"
    >   
      <action-button
        border-color="border-transparent"
        text-color="text-white"
        bg-color="bg-indigo-600"
        bg-color-square="bg-indigo-600"
        icon-color="text-white"
        libelle="DÉPOSER UN FICHIER"
        :uppercase="true"
        icon="file-add"
        :responsive="true"
        type-shadow="indigo-shadow"
        @clickAction="changeStatePopupAddNewFile(1)"
      />
      <action-button
        border-color="border-indigo-600"
        text-color="text-pink-600"
        bg-color="bg-white"
        bg-color-square="bg-white"
        icon-color="text-pink-600"
        libelle="CRÉER UN DOSSIER"
        :uppercase="true"
        icon="folder-add"
        :responsive="true"
        @clickAction="displayPopupAddNewFolder(true)"
      />
    </div>
    <illustration name="evaluation" />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

import Illustration from './../../components/Illustration';
import ActionButton from './../../components/ActionButton';

import CreateNewFolder from './popup/CreateNewFolder.vue';
import AddNewFile from './popup/AddNewFile.vue';

export default {
  components:{
    Illustration,
    ActionButton,
    CreateNewFolder,
    AddNewFile,
  },

  data(){
    return {

      isCreateFolderPopupDisplayed: false,
      errorsCreateNewFolder: {},

      stateAddFilePopup: -1,
      fileTemp:{
        id: null,
        path: '',
        finalPath: '',
        name: '',
      },
      errorsAddNewFile:{},
      addNewFileLoading:false,
    };
  },

  methods:{
    ...mapActions({
      createNewFolder:'depotDocuments/createNewFolder',
      addNewTempFile: 'depotDocuments/addNewTempFile',
      addNewFile: 'depotDocuments/addNewFile',
    }),

    displayPopupAddNewFolder(state){
      this.isCreateFolderPopupDisplayed = state;
      this.errorsCreateNewFolder={};
    },

    changeStatePopupAddNewFile(state){
      this.stateAddFilePopup = state;
      this.errorsAddNewFile = {};
      this.addNewFileLoading = false;
    },

    async createFolder(folder){
      try{
        await this.createNewFolder(folder).then(response => {
          this.isCreateFolderPopupDisplayed = false;
          this.errorsCreateNewFolder={};
        });
      }
      catch(err){
        this.errorsCreateNewFolder = err;
      }
    },

    async addTempFile(data){
      try{
        this.addNewFileLoading = true;
        await this.addNewTempFile(data).then(response => {
          //the API returns the temporary path of the file
          this.fileTemp.path = response;
          this.fileTemp.finalPath = response.replace('tmp/'+this.user.id+'/', '');
          this.stateAddFilePopup = 2;
          this.addNewFileLoading = false;
        });
      }
      catch(err){
        this.errorsAddNewFile = err;
        this.addNewFileLoading = false;
      }
    },

    async addFile(infos){
      try{
        await this.addNewFile(infos).then(response => {
          this.stateAddFilePopup = -1;
        });
      }
      catch(err){
        this.errorsAddNewFile = err;
      }
    },
  },

  computed:{
    ...mapGetters({
      user: 'auth/user',
    }),

    currentPage() {
      return this.$route.path;
    },

    canEdit(){
      let userId = (this.currentPage.includes('/form/neopass/')) ? parseInt(this.currentPage.split('/form/neopass/')[1].split('/')[0]) : this.user.id;

      return !this.currentPage.includes('/form/neopass/') || this.$can('documents_edit', userId);
    }
  },
};
</script>